import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-压裂分析_泵注程序维护",
  "use": "icon-压裂分析_泵注程序维护-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-压裂分析_泵注程序维护\">\n<g>\n\t<path d=\"M6.9,7.7h-6v-6h6V7.7z M1.9,6.7h4v-4h-4V6.7z\" />\n\t<path d=\"M11.2,8.6L7.4,4.7l3.8-3.8l3.8,3.8L11.2,8.6z M8.8,4.7l2.4,2.4l2.4-2.4l-2.4-2.4L8.8,4.7z\" />\n\t<path d=\"M14.2,15.1h-6v-6h6V15.1z M9.2,14.1h4v-4h-4V14.1z\" />\n\t<path d=\"M6.9,15.1h-6v-6h6V15.1z M1.9,14.1h4v-4h-4V14.1z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol